function consent(text,accept,info,hide,url,age,dismiss){

	/*get timestamps*/
	var unix = Math.round((new Date()).getTime() / 1000);
	var expire = age*24*60*60;

	/*if not set or deprecated*/
	if(
		(localStorage['policy'] == null) ||
		((localStorage['policy'] != '') && (localStorage['policy'] < unix-expire))
	){

		/*show notification*/
		$('html').append('<div class="policy"><span>'+text+'</span><div class="box"><a href="'+url+'" target="_blank">'+info+'</a><a class="accept">'+accept+'</a><a class="hide">'+hide+'</a></div></div>');

	}else{
		/*tracking already enabled, so track*/
		optin();
	}

	/*accept*/
	$('.accept').click(function(){
		localStorage['policy'] = unix;
		optin();
		$('.policy').remove();
	});

	/*dimiss*/
	$('.hide').click(function(){
		$('.policy').remove();
	});

}


/*tracking*/
window.dataLayer = window.dataLayer || [];
function gtag(){
	dataLayer.push(arguments);
}
function optin(){

	/*tag manager for google ads*/
	(function (w, d, s, l, i) {
		w[l] = w[l] || [];
		w[l].push({
			'gtm.start':
				new Date().getTime(), event: 'gtm.js'
		});
		var f = d.getElementsByTagName(s)[0],
			j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : '';
		j.async = true;
		j.src =
			'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
		f.parentNode.insertBefore(j, f);
	})(window, document, 'script', 'dataLayer', 'GTM-TF57RKL');

	/*google maps*/
	if (typeof loadMap !== 'undefined' && $.isFunction(loadMap)) {
		loadMap();
	}

	gtag('consent', 'default', {
		'ad_storage': 'granted',
		'ad_user_data': 'granted',
		'ad_personalization': 'granted',
		'analytics_storage': 'granted',
		'personalization_storage': 'granted',
		'security_storage': 'granted'
	});

	gtag('consent', 'update', {
		'ad_storage': 'granted',
		'ad_user_data': 'granted',
		'ad_personalization': 'granted',
		'analytics_storage': 'granted',
		'personalization_storage': 'granted',
		'security_storage': 'granted'
	});

	/*locally*/
	$('section.locally .rail')
		.contents()
		.filter(function(){return this.nodeType === 8;})
		.replaceWith(function(){return this.data;});
	$('section.locally .notice').remove();

}




